// components/BusinessHoursEditor.js
import { useEffect, useState } from 'react';
import {
  Box, Button, CircularProgress, FormControlLabel, Switch, TextField, Typography
} from '@mui/material';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { useBusinessHours } from '../../../hook/useBusinessHours';


const validationSchema = yup.object().shape({
  open_time: yup.string().required(),
  close_time: yup.string().required(),
});

const DAYS_ORDER = [
    'monday',
    'tuesday',
    'wednesday',
    'thursday',
    'friday',
    'saturday',
    'sunday',
  ];

export default function BusinessHoursEditor({ location }) {
  const [hours, setHours] = useState([]);
  const [saving, setSaving] = useState(false);
  const { editBusinessHour } = useBusinessHours();

  useEffect(() => {
    if (location) {
      const ordered = [...location.business_hours].sort(
        (a, b) => DAYS_ORDER.indexOf(a.day) - DAYS_ORDER.indexOf(b.day)
      );
      setHours(ordered);
    }
  }, [location]);

  const handleChange = (index, field, value) => {
    const newHours = [...hours];
    newHours[index][field] = value;
    setHours(newHours);
  };

  const handleSave = async () => {
    setSaving(true);
    try {
      await Promise.all(
        hours.map(hour => editBusinessHour(hour.id, {
          open_time: hour.open_time,
          close_time: hour.close_time,
          is_closed: hour.is_closed
        }))
      );
      alert("Horarios actualizados correctamente");
    } catch (error) {
      console.error(error);
      alert("Hubo un error al guardar");
    }
    setSaving(false);
  };

  return (
    <Box mt={3}>
      <Typography variant="h6">Editar horarios de atención</Typography>
      {hours.map((item, index) => (
        <Box
          key={item.id}
          display="flex"
          alignItems="center"
          gap={2}
          py={1}
        >
          <Typography width="120px" textTransform="capitalize">{item.day}</Typography>
          <TextField
            type="time"
            label="Apertura"
            value={item.open_time}
            onChange={(e) => handleChange(index, 'open_time', e.target.value)}
            size="small"
            disabled={item.is_closed}
          />
          <TextField
            type="time"
            label="Cierre"
            value={item.close_time}
            onChange={(e) => handleChange(index, 'close_time', e.target.value)}
            size="small"
            disabled={item.is_closed}
          />
          <FormControlLabel
            control={
              <Switch
                checked={item.is_closed}
                onChange={(e) => handleChange(index, 'is_closed', e.target.checked)}
              />
            }
            label="¿Cerrado?"
          />
        </Box>
      ))}
      <Box mt={2}>
        <Button
          variant="contained"
          onClick={handleSave}
          disabled={saving}
        >
          {saving ? <CircularProgress size={20} /> : 'Guardar cambios'}
        </Button>
      </Box>
    </Box>
  );
}
